"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _theme = _interopRequireDefault(require("../AirasiaClassic/theme"));
var _theme2 = _interopRequireDefault(require("./theme"));
const AirasiaDark = _ref => {
  let {
    children
  } = _ref;
  const theme = {
    ..._theme.default,
    ..._theme2.default
  };
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, children);
};
AirasiaDark.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
var _default = exports.default = AirasiaDark;